import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { Student, Lock, ArrowRight, Info } from "@phosphor-icons/react";
import { Button } from "../components/ui/button";
import { Input } from "../components/ui/input";
import { Label } from "../components/ui/label";
import api, { formatApiError } from "../lib/api";

export default function WaliLoginPage() {
  const nav = useNavigate();
  const [form, setForm] = useState({ nis: "", phone: "" });
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (!form.nis.trim() || !form.phone.trim()) return toast.error("NIS dan No HP wajib diisi");
    setLoading(true);
    try {
      const { data } = await api.post("/wali/login", { nis: form.nis.trim(), phone: form.phone.trim() });
      localStorage.setItem("wali_token", data.token);
      localStorage.setItem("wali_siswa", JSON.stringify(data.siswa));
      toast.success(`Selamat datang, Wali ${data.siswa.name}`);
      nav("/portal-wali");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || "Login gagal");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4 bg-gradient-to-br from-[#E6F7F7] via-white to-[#CCEEEF] dark:from-slate-900 dark:via-slate-900 dark:to-slate-800">
      <div className="w-full max-w-md">
        <div className="text-center mb-8">
          <div className="inline-flex h-16 w-16 items-center justify-center rounded-2xl bg-gradient-to-br from-[#48B8BD] to-[#0B8D95] shadow-lg mb-4">
            <Student size={32} weight="duotone" className="text-white" />
          </div>
          <div className="text-xs uppercase tracking-[0.25em] text-[#0B8D95] font-bold mb-1">Portal Wali Murid</div>
          <h1 className="font-display text-3xl font-black text-foreground tracking-tight">Masuk Akun</h1>
          <p className="text-sm text-muted-foreground mt-2">Pantau tagihan & riwayat pembayaran anak Anda</p>
        </div>

        <form onSubmit={submit} className="bg-card border border-border rounded-2xl p-6 shadow-sm space-y-4">
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">NIS Siswa</Label>
            <Input value={form.nis} onChange={(e) => setForm({ ...form, nis: e.target.value })}
              placeholder="Masukkan NIS anak Anda" data-testid="wali-nis-input" className="mt-1.5" />
          </div>
          <div>
            <Label className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">Nomor HP Wali</Label>
            <Input value={form.phone} onChange={(e) => setForm({ ...form, phone: e.target.value })}
              placeholder="0812xxxxxxx" data-testid="wali-phone-input" className="mt-1.5" />
            <div className="mt-1.5 text-[11px] text-muted-foreground flex items-start gap-1">
              <Info size={12} className="mt-0.5 shrink-0" /> No HP harus sama dengan yang terdaftar di data siswa.
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full gap-2 h-11 mt-2" data-testid="wali-login-submit">
            <Lock size={16} /> {loading ? "Memproses..." : "Masuk Portal"} <ArrowRight size={16} />
          </Button>
        </form>

        <div className="text-center mt-6 text-xs text-muted-foreground">
          Bukan wali murid? <a href="/login" className="text-[#0B8D95] font-semibold hover:underline">Login Staf/Karyawan</a>
        </div>
      </div>
    </div>
  );
}
